export default {
    apiHost: 'https://api.tomatolearn.com',
}
